module.exports = __webpack_public_path__ + "img/127.01059bcc.jpg";